var dt = Object.defineProperty, ft = Object.defineProperties;
var vt = Object.getOwnPropertyDescriptors;
var ze = Object.getOwnPropertySymbols;
var mt = Object.prototype.hasOwnProperty, pt = Object.prototype.propertyIsEnumerable;
var Xe = (n, e, t) => e in n ? dt(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, l = (n, e) => {
  for (var t in e || (e = {}))
    mt.call(e, t) && Xe(n, t, e[t]);
  if (ze)
    for (var t of ze(e))
      pt.call(e, t) && Xe(n, t, e[t]);
  return n;
}, v = (n, e) => ft(n, vt(e));
import { watch as M, toRefs as xe, reactive as Qe, toRaw as ht, computed as T, shallowRef as pe, triggerRef as Ye, unref as c, nextTick as ve, ref as F, isRef as gt, inject as et, readonly as De, defineComponent as C, onMounted as z, createElementBlock as b, openBlock as p, toDisplayString as fe, onBeforeUnmount as U, mergeDefaults as ie, createBlock as V, Teleport as yt, mergeProps as qe, Fragment as tt, renderList as _t, normalizeStyle as Te, renderSlot as J, normalizeProps as I, guardReactiveProps as w, createCommentVNode as H, withCtx as oe, createVNode as $e, toRef as Se, shallowReactive as Et, provide as bt, createElementVNode as A, markRaw as R, normalizeClass as W, Transition as St, resolveDynamicComponent as He } from "vue";
const L = "Notivue__", Ct = 6e3, f = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
  PROMISE: "promise",
  PROMISE_RESOLVE: "promise-resolve",
  PROMISE_REJECT: "promise-reject"
}, me = {
  title: "",
  message: "",
  duration: Ct,
  ariaLive: "polite",
  ariaRole: "status"
}, Me = v(l({}, me), {
  ariaLive: "assertive",
  ariaRole: "alert"
}), Tt = v(l({}, me), {
  duration: 1 / 0
}), At = v(l({}, Me), {
  ariaLive: "polite"
}), Rt = l({}, me), Ft = {
  [f.SUCCESS]: me,
  [f.ERROR]: Me,
  [f.WARNING]: At,
  [f.INFO]: Rt,
  [f.PROMISE]: Tt,
  [f.PROMISE_RESOLVE]: me,
  [f.PROMISE_REJECT]: Me
}, nt = {
  pauseOnHover: !0,
  pauseOnTouch: !0,
  pauseOnTabChange: !0,
  enqueue: !1,
  position: "top-center",
  teleportTo: "body",
  notifications: Ft,
  limit: 1 / 0,
  avoidDuplicates: !1,
  animations: {
    enter: L + "enter",
    leave: L + "leave",
    clearAll: L + "clearAll"
  }
}, se = wt();
function It(n) {
  Object.assign(se, n);
}
function st(n) {
  let e = 0;
  function t(s, o, r = `${e++}`) {
    return typeof s == "string" && (s = { message: s }), n.push(v(l({}, s), { id: r, type: o })), {
      id: r,
      clear: () => n.clear(r),
      destroy: () => n.clear(r, { isDestroy: !0 })
    };
  }
  return {
    success: (s) => t(s, f.SUCCESS),
    error: (s) => t(s, f.ERROR),
    warning: (s) => t(s, f.WARNING),
    info: (s) => t(s, f.INFO),
    promise: (s) => {
      const { id: o, clear: r, destroy: i } = t(s, f.PROMISE);
      return {
        resolve: (d) => t(d, f.PROMISE_RESOLVE, o),
        reject: (d) => t(d, f.PROMISE_REJECT, o),
        success: (d) => t(d, f.PROMISE_RESOLVE, o),
        error: (d) => t(d, f.PROMISE_REJECT, o),
        clear: r,
        destroy: i
      };
    },
    load(s) {
      return this.promise(s);
    },
    clearAll: () => n.clearAll(),
    destroyAll: () => n.destroyAll()
  };
}
function wt() {
  const n = new Proxy({}, { get: () => () => {
  } });
  return st(n);
}
function Pt(n) {
  M(
    n.config.isTopAlign,
    () => {
      n.animations.updatePositions({ isImmediate: !0 });
    },
    { flush: "post" }
  ), M(
    () => n.items.length,
    () => {
      n.animations.updatePositions();
    },
    { flush: "post" }
  ), M(
    () => n.items.length === 0 && n.queue.length === 0,
    (e) => {
      e && (n.timeouts.reset(), n.elements.setRootAttrs({}));
    },
    { flush: "post" }
  ), M(
    () => n.config.animations.value.enter,
    (e, t) => {
      e !== t && n.animations.resetTransitionData();
    }
  );
}
const ke = typeof window == "undefined";
function G(n) {
  return n.pointerType === "mouse";
}
function je(n, e) {
  const t = l({}, n);
  for (const s in e)
    e.hasOwnProperty(s) && (Lt(e[s]) ? t[s] = je(n[s], e[s]) : t[s] = e[s]);
  return t;
}
function Ot(n, e) {
  return e.props || (e.props = {}), l(l(l(l({}, n[e.type]), n.global), e), e.type === "promise" ? { duration: 1 / 0 } : {});
}
function Lt(n) {
  if (Object.prototype.toString.call(n) !== "[object Object]")
    return !1;
  const e = Object.getPrototypeOf(n);
  return e === null || Object.getPrototypeOf(e) === null;
}
function Nt(n, e) {
  return xe(Qe(je(n, e)));
}
function Dt(n) {
  return Object.entries(n).reduce(
    (e, [t, { value: s }]) => v(l({}, e), { [t]: ht(s) }),
    {}
  );
}
const Mt = (n) => n === f.SUCCESS || n === f.ERROR || n === f.WARNING || n === f.INFO, xt = [
  "timeout",
  "resumedAt",
  "remaining",
  "animationAttrs",
  "positionStyles"
];
function Ce(n) {
  return Object.fromEntries(
    Object.entries(n).filter(
      ([e]) => !xt.includes(e)
    )
  );
}
function ot(n) {
  return `${n.title ? `${n.title}: ` : ""}${n.message}`;
}
let $t = () => {
};
function kt(n) {
  const e = Nt(nt, n), t = T(() => e.position.value.startsWith("top"));
  function s(o) {
    typeof o == "function" && (o = o(Dt(e)));
    for (const r of Object.keys(o))
      typeof e[r].value == "object" ? e[r].value = je(e[r].value, o[r]) : e[r].value = o[r];
  }
  return $t = s, v(l({}, e), { isTopAlign: t, update: s });
}
function jt() {
  return {
    entries: pe([]),
    get length() {
      return this.entries.value.length;
    },
    add(n) {
      this.entries.value.push(n), this.triggerRef();
    },
    get(n) {
      return this.entries.value.find((e) => e.id === n);
    },
    update(n, e) {
      var t;
      Object.assign((t = this.get(n)) != null ? t : {}, e);
    },
    triggerRef() {
      Ye(this.entries);
    },
    remove(n) {
      this.entries.value = this.entries.value.filter((e) => e.id !== n);
    },
    clear() {
      this.entries.value = [];
    }
  };
}
function Ut(n, e) {
  return {
    entries: pe([]),
    get length() {
      return this.entries.value.length;
    },
    add(t) {
      this.entries.value.unshift(t), this.triggerRef();
    },
    addFromQueue() {
      const t = v(l({}, e.entries.value[0]), {
        timeout: e.entries.value[0].timeout(),
        createdAt: Date.now()
      });
      e.remove(t.id), this.add(t);
    },
    findDupe(t) {
      return this.entries.value.find(
        (s) => c(s.message).replace(/\uFEFF/g, "") === c(t.message).replace(/\uFEFF/g, "") && // prettier-ignore
        c(s.title) === c(t.title) && s.type === t.type
      );
    },
    get(t) {
      return this.entries.value.find((s) => s.id === t);
    },
    update(t, s) {
      var o;
      Object.assign((o = this.get(t)) != null ? o : {}, s);
    },
    triggerRef() {
      Ye(this.entries);
    },
    updateAll(t) {
      this.entries.value = this.entries.value.map(t);
    },
    remove(t) {
      this.entries.value = this.entries.value.filter((o) => o.id !== t), e.length > 0 && this.length < n.limit.value && ve(() => this.addFromQueue());
    },
    clear() {
      this.entries.value = [], e.clear();
    }
  };
}
function Bt() {
  return {
    root: F(null),
    rootAttrs: pe({}),
    setRootAttrs(n) {
      this.rootAttrs.value = n;
    },
    items: F([]),
    getSortedItems() {
      return this.items.value.sort((n, e) => +e.dataset.notivueId - +n.dataset.notivueId);
    },
    containers: F([])
  };
}
function Kt(n, e, t) {
  return {
    isReducedMotion: F(!1),
    transitionData: null,
    setReducedMotion(s) {
      this.isReducedMotion.value = s;
    },
    getTransitionData() {
      return this.transitionData || this.setTransitionData(), this.transitionData;
    },
    resetTransitionData() {
      this.transitionData = null;
    },
    setTransitionData() {
      var r;
      const s = n.animations.value.enter, o = s ? (r = t.root.value) == null ? void 0 : r.querySelector(`.${s}`) : null;
      if (!o)
        this.transitionData = { duration: "0s", easing: "ease" };
      else {
        const i = window.getComputedStyle(o);
        this.transitionData = {
          duration: i.animationDuration,
          easing: i.animationTimingFunction
        };
      }
    },
    playLeave(s, { isDestroy: o = !1, isUserTriggered: r = !1 } = {}) {
      const i = e.get(s);
      window.clearTimeout(i == null ? void 0 : i.timeout);
      function d(h) {
        var S;
        h && h.currentTarget !== h.target || (e.remove(s), (S = i == null ? void 0 : i[r ? "onManualClear" : "onAutoClear"]) == null || S.call(i, Ce(i)));
      }
      const { leave: g = "" } = n.animations.value;
      if (!i || !g || o || this.isReducedMotion.value)
        return d();
      e.update(s, {
        positionStyles: v(l({}, i.positionStyles), {
          zIndex: -1
        }),
        animationAttrs: {
          class: g,
          onAnimationend: d
        }
      }), this.updatePositions();
    },
    playClearAll() {
      const { clearAll: s = "" } = n.animations.value;
      if (e.entries.value.forEach((o) => window.clearTimeout(o.timeout)), !s || this.isReducedMotion.value)
        return e.clear();
      t.setRootAttrs({
        class: s,
        onAnimationend: () => e.clear()
      });
    },
    updatePositions({ isImmediate: s = !1 } = {}) {
      const o = this.isReducedMotion.value || s, r = n.animations.value.leave;
      let i = 0;
      for (const d of t.getSortedItems()) {
        const g = d.dataset.notivueId, h = e.get(g);
        if (!d || !h || h.animationAttrs.class === r)
          continue;
        const { duration: S, easing: _ } = this.getTransitionData();
        e.update(g, {
          positionStyles: l({
            willChange: "transform",
            transform: `translate3d(0, ${i}px, 0)`
          }, o ? { transition: "none" } : { transitionDuration: S, transitionTimingFunction: _ })
        }), i += (n.isTopAlign.value ? 1 : -1) * d.clientHeight;
      }
      e.triggerRef();
    }
  };
}
function Zt(n, e) {
  return {
    isStreamPaused: F(!1),
    isStreamFocused: F(!1),
    debounceTimeout: void 0,
    setStreamPause(t = !0) {
      this.isStreamPaused.value = t;
    },
    setStreamFocus(t = !0) {
      this.isStreamFocused.value = t;
    },
    clearDebounceTimeout() {
      window.clearTimeout(this.debounceTimeout);
    },
    reset() {
      this.clearDebounceTimeout(), this.setStreamPause(!1), this.setStreamFocus(!1);
    },
    create(t, s) {
      if (!this.isStreamPaused.value && Number.isFinite(s) && s > 0)
        return window.setTimeout(() => e.playLeave(t), s);
    },
    pause() {
      n.length === 0 || this.isStreamPaused.value || (this.setStreamPause(), n.updateAll((t) => {
        var o;
        if (window.clearTimeout(t.timeout), t.duration === 1 / 0)
          return t;
        let s = 0;
        return t.remaining == null ? s = t.duration - (Date.now() - ((o = t.resumedAt) != null ? o : t.createdAt)) : s = t.remaining - (Date.now() - t.resumedAt), v(l({}, t), {
          remaining: s
        });
      }));
    },
    resume() {
      n.length === 0 || !this.isStreamPaused.value || (this.setStreamPause(!1), n.updateAll((t) => {
        var s;
        return window.clearTimeout(t.timeout), t.duration === 1 / 0 ? t : v(l({}, t), {
          timeout: this.create(t.id, (s = t.remaining) != null ? s : t.duration),
          resumedAt: Date.now()
          // ...which corresponds to the duration itself when the stream is resumed for the first time
        });
      }));
    },
    resumeWithDebounce(t) {
      this.debounceTimeout = window.setTimeout(() => {
        this.resume();
      }, t);
    }
  };
}
function Wt({
  config: n,
  items: e,
  queue: t,
  animations: s,
  timeouts: o
}) {
  return {
    destroyAll() {
      e.clear();
    },
    clearAll() {
      s.playClearAll();
    },
    clear(r, { isDestroy: i = !1 } = {}) {
      var g;
      ((g = e.entries.value[e.entries.value.length - 1]) == null ? void 0 : g.id) === r && o.resume(), s.playLeave(r, { isUserTriggered: !0, isDestroy: i });
    },
    push(r) {
      const i = Ot(n.notifications.value, r), d = Date.now();
      if (n.avoidDuplicates.value && Mt(i.type)) {
        const h = e.findDupe(i);
        h && (window.clearTimeout(h.timeout), e.update(h.id, {
          createdAt: d,
          duration: i.duration,
          remaining: void 0,
          timeout: o.create(h.id, i.duration),
          duplicateCount: h.duplicateCount + 1
        }), gt(h.message) ? h.message.value += "\uFEFF" : h.message += "\uFEFF", e.triggerRef());
        const S = e.findDupe.call(t, i);
        if (S && t.update(S.id, {
          duration: i.duration,
          createdAt: d,
          duplicateCount: S.duplicateCount + 1
        }), S || h)
          return;
      }
      const g = () => o.create(i.id, i.duration);
      if (r.type === f.PROMISE_RESOLVE || r.type === f.PROMISE_REJECT)
        t.get(i.id) ? (t.update(i.id, v(l({}, i), { createdAt: d, timeout: g })), t.triggerRef()) : (e.update(i.id, v(l({}, i), { createdAt: d, timeout: g() })), e.triggerRef());
      else {
        const h = n.enqueue.value, S = e.length >= n.limit.value, _ = !h && S, m = h && !r.skipQueue && S;
        _ && e.entries.value.slice(n.limit.value - 1).forEach((E) => o.create(E.id, 1));
        const k = v(l({}, i), {
          createdAt: d,
          duplicateCount: 0,
          animationAttrs: {
            class: s.isReducedMotion.value ? "" : n.animations.value.enter,
            onAnimationend() {
              e.update(i.id, {
                animationAttrs: { class: "", onAnimationend: void 0 }
              });
            }
          },
          timeout: m ? g : g(),
          clear: () => this.clear(i.id),
          destroy: () => this.clear(i.id, { isDestroy: !0 })
        });
        m ? t.add(k) : e.add(k);
      }
    }
  };
}
const it = Symbol("");
function Hn(n = {}) {
  const e = kt(n), t = jt(), s = Ut(e, t), o = Bt(), r = Kt(e, s, o), i = Zt(s, r), d = { config: e, queue: t, items: s, elements: o, animations: r, timeouts: i }, g = Wt(d), h = Object.freeze(st(g));
  return It(h), Pt(d), {
    install(_) {
      _.config.globalProperties.$push = h, _.provide(it, d);
    }
  };
}
function x() {
  return et(it);
}
function Ue() {
  return ke ? v(l({}, xe(Qe(nt))), {
    isTopAlign: T(() => !0),
    isStreamPaused: De(F(!1)),
    update: () => {
    }
  }) : v(l({}, x().config), { isStreamPaused: De(x().timeouts.isStreamPaused) });
}
function Gn() {
  return se;
}
function Vn() {
  if (ke)
    return {
      entries: T(() => []),
      queue: T(() => [])
    };
  const n = x();
  return {
    entries: T(() => n.items.entries.value.map(Ce)),
    queue: T(() => n.queue.entries.value.map(Ce))
  };
}
const Be = {
  listAriaLabel: "Notifications"
}, Ke = C({
  setup(n, { slots: e, attrs: t }) {
    const s = F(!1);
    return z(() => s.value = !0), () => {
      var o;
      return s.value ? (o = e.default) == null ? void 0 : o.call(e) : b("span", t, "");
    };
  }
}), zt = ["role", "aria-live"], Xt = /* @__PURE__ */ C({
  __name: "AriaLive",
  props: {
    item: {}
  },
  setup(n) {
    const e = n, t = {
      position: "absolute",
      width: "1px",
      height: "1px",
      padding: "0",
      margin: "-1px",
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      border: "0"
    };
    return (s, o) => (p(), b("div", {
      style: t,
      role: e.item.ariaRole,
      "aria-live": e.item.ariaLive,
      key: `${s.item.id}_${s.item.type}`,
      "aria-atomic": "true"
    }, fe(c(ot)(e.item)), 9, zt));
  }
});
function qt() {
  const { timeouts: n, config: e } = x();
  function t(o) {
    G(o) && n.pause();
  }
  function s(o) {
    G(o) && n.resume();
  }
  return T(
    () => e.pauseOnHover.value && !n.isStreamFocused.value ? {
      onPointerenter: t,
      onPointerleave: s
    } : {}
  );
}
function Ht() {
  const { timeouts: n, config: e } = x();
  function t(s) {
    G(s) || (n.clearDebounceTimeout(), n.pause(), n.resumeWithDebounce(2e3));
  }
  return U(() => {
    n.clearDebounceTimeout();
  }), T(
    () => e.pauseOnTouch.value && !n.isStreamFocused.value ? { onPointerdown: t } : {}
  );
}
const we = { boxSizing: "border-box" }, Pe = {
  list: v(l({}, we), {
    display: "flex",
    justifyContent: "center",
    listStyle: "none",
    margin: "0 auto",
    maxWidth: "var(--nv-root-width, 100%)",
    padding: "0",
    pointerEvents: "none",
    position: "fixed",
    zIndex: "var(--nv-z, 500)"
  }),
  listItem: v(l({}, we), {
    display: "flex",
    margin: "0",
    position: "absolute",
    transitionProperty: "transform",
    width: "100%"
  }),
  itemContainer: v(l({}, we), {
    maxWidth: "100%",
    padding: "0 0 var(--nv-gap, 0.75rem) 0",
    pointerEvents: "auto"
  })
};
function Gt() {
  const { isTopAlign: n, position: e } = Ue(), t = T(() => {
    const o = n.value, r = [
      `var(--nv-root-top, ${o ? "1.25rem" : "0px"})`,
      "var(--nv-root-right, 1.25rem)",
      `var(--nv-root-bottom, ${o ? "0px" : "1.25rem"})`,
      "var(--nv-root-left, 1.25rem)"
    ], i = r.map((d) => `calc(-1 * ${d})`);
    return o ? i.splice(2, 1, "0px") : i.splice(0, 1, "0px"), { inset: r.join(" "), clipPath: `inset(${i.join(" ")})` };
  }), s = T(() => ({
    [n.value ? "top" : "bottom"]: "0",
    justifyContent: `var(--nv-root-x-align, ${e.value.endsWith("left") ? "flex-start" : e.value.endsWith("right") ? "flex-end" : "center"})`
  }));
  return T(() => ({
    list: l(l({}, Pe.list), t.value),
    listItem: l(l({}, Pe.listItem), s.value),
    itemContainer: Pe.itemContainer
  }));
}
function Vt(n) {
  function e() {
    window.matchMedia("(max-width: 1100px)").matches && n();
  }
  z(() => {
    window.addEventListener("resize", e);
  }), U(() => {
    window.removeEventListener("resize", e);
  });
}
function Jt(n, e) {
  let t;
  const s = /* @__PURE__ */ new Set();
  z(() => {
    t = new ResizeObserver((o, r) => {
      o.forEach((i) => {
        s.has(i.target) ? (e(), s.delete(i.target), r.unobserve(i.target)) : s.add(i.target);
      });
    });
  }), M(
    n,
    (o) => {
      o.length > 0 && o.forEach((r) => t == null ? void 0 : t.observe(r));
    },
    { flush: "post" }
  ), U(() => {
    t == null || t.disconnect();
  });
}
function Qt() {
  const { elements: n, animations: e } = x();
  Vt(() => e.updatePositions({ isImmediate: !0 })), Jt(n.items.value, () => e.updatePositions());
}
function Yt() {
  const { items: n, config: e, timeouts: t } = x();
  function s() {
    t.isStreamFocused.value || e.pauseOnTabChange.value && t.resume();
  }
  function o() {
    t.isStreamFocused.value || (e.pauseOnTabChange.value ? t.pause() : n.clear());
  }
  z(() => {
    window.addEventListener("focus", s), window.addEventListener("blur", o);
  }), U(() => {
    window.removeEventListener("focus", s), window.removeEventListener("blur", o);
  });
}
function en() {
  const { animations: n } = x(), e = window.matchMedia("(prefers-reduced-motion: reduce)"), t = () => n.setReducedMotion(e.matches);
  z(() => {
    var s;
    t(), (s = e.addEventListener) == null || s.call(e, "change", t);
  }), U(() => {
    var s;
    (s = e.removeEventListener) == null || s.call(e, "change", t);
  });
}
const tn = ["data-notivue-align", "aria-label"], nn = ["data-notivue-id", "aria-setsize", "aria-posinset"], sn = ["aria-label", "tabindex", "data-notivue-container"], at = /* @__PURE__ */ C({
  __name: "NotivueImpl",
  props: /* @__PURE__ */ ie({
    class: {},
    containersTabIndex: {},
    listAriaLabel: {},
    styles: {}
  }, Be),
  setup(n) {
    const e = n, { config: t, items: s, elements: o } = x(), r = Gt(), i = qt(), d = Ht();
    return en(), Yt(), Qt(), (g, h) => {
      var S;
      return p(), V(yt, {
        to: c(t).teleportTo.value === !1 ? void 0 : c(t).teleportTo.value,
        disabled: c(t).teleportTo.value === !1
      }, [
        c(s).length > 0 ? (p(), b("ol", qe({ key: 0 }, l(l(l({}, c(i)), c(d)), c(o).rootAttrs.value), {
          "data-notivue-align": c(t).isTopAlign.value ? "top" : "bottom",
          "aria-label": e.listAriaLabel,
          ref: c(o).root,
          class: e.class,
          style: l(l({}, c(r).list), (S = e.styles) == null ? void 0 : S.list)
        }), [
          (p(!0), b(tt, null, _t(c(s).entries.value, (_, m) => {
            var k, E, B, N;
            return p(), b("li", {
              tabindex: "-1",
              key: _.id,
              "data-notivue-id": _.id,
              "aria-setsize": c(s).length,
              "aria-posinset": m + 1,
              ref_for: !0,
              ref: c(o).items,
              style: Te(l(l(l({}, c(r).listItem), _.positionStyles), (k = e.styles) == null ? void 0 : k.listItem))
            }, [
              _.ariaLiveOnly ? (p(), V(Xt, {
                key: 0,
                item: _
              }, null, 8, ["item"])) : (p(), b("div", qe({ key: 1 }, _.animationAttrs, {
                "aria-label": c(ot)(_),
                tabindex: (B = (E = g.containersTabIndex) == null ? void 0 : E[_.id]) != null ? B : -1,
                "data-notivue-container": _.id,
                ref_for: !0,
                ref: c(o).containers,
                style: l(l({}, c(r).itemContainer), (N = e.styles) == null ? void 0 : N.itemContainer)
              }), [
                J(g.$slots, "default", I(w(c(Ce)(_))))
              ], 16, sn))
            ], 12, nn);
          }), 128))
        ], 16, tn)) : H("", !0)
      ], 8, ["to", "disabled"]);
    };
  }
}), Jn = /* @__PURE__ */ C({
  __name: "Notivue",
  props: /* @__PURE__ */ ie({
    class: {},
    containersTabIndex: {},
    listAriaLabel: {},
    styles: {}
  }, Be),
  setup(n) {
    const e = n;
    return (t, s) => (p(), V(c(Ke), null, {
      default: oe(() => [
        $e(at, I(w(e)), {
          default: oe((o) => [
            J(t.$slots, "default", I(w(o)))
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }));
  }
}), Qn = /* @__PURE__ */ C({
  __name: "Notivue",
  props: /* @__PURE__ */ ie({
    class: {},
    containersTabIndex: {},
    listAriaLabel: {},
    styles: {}
  }, Be),
  setup(n) {
    const e = n;
    function t(i) {
      const d = se[i.detail.type](i.detail);
      window.dispatchEvent(
        new CustomEvent(i.detail.resultEventName, {
          detail: d
        })
      );
    }
    const r = [
      ["notivue:push", t],
      ["notivue:clear-all", () => se.clearAll()],
      ["notivue:destroy-all", () => se.destroyAll()]
    ];
    return z(() => {
      r.forEach(([i, d]) => window.addEventListener(i, d));
    }), U(() => {
      r.forEach(([i, d]) => window.removeEventListener(i, d));
    }), (i, d) => (p(), V(c(Ke), null, {
      default: oe(() => [
        $e(at, I(w(e)), {
          default: oe((g) => [
            J(i.$slots, "default", I(w(g)))
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }));
  }
}), on = {
  touchOnly: !1,
  exclude: "a, button",
  disabled: !1,
  threshold: 0.5
}, an = 300, Oe = {
  Mouse: 200,
  Touch: 1e3,
  TouchExternal: 1400
}, Yn = /* @__PURE__ */ C({
  __name: "NotivueSwipe",
  props: /* @__PURE__ */ ie({
    item: {},
    touchOnly: { type: Boolean },
    exclude: {},
    disabled: { type: Boolean },
    threshold: {},
    destroy: { type: Boolean }
  }, on),
  setup(n) {
    const { items: e, timeouts: t, elements: s, animations: o } = x(), r = n, i = Se(r, "touchOnly"), d = Se(r, "exclude"), g = Se(r, "disabled"), h = Se(r, "threshold"), S = T(() => r.item.type === f.PROMISE), _ = T(
      () => !t.isStreamFocused.value && !g.value && !S.value && r.item.duration < 1 / 0
    ), m = F(null), k = {
      isPressed: !1,
      isClearing: !1,
      startX: 0,
      currentX: 0
    }, E = Et(k), B = pe({});
    function N(u) {
      Object.assign(E, u);
    }
    function Q(u) {
      B.value = l(l({}, B.value), u);
    }
    function D() {
      B.value = {};
    }
    M(
      () => e.length,
      (u, a) => {
        u !== a && E.isPressed && (ae(), N(k));
      },
      { flush: "post" }
    );
    function ge() {
      m.value && (Q({
        touchAction: "none",
        userSelect: "none",
        cursor: "grab"
      }), m.value.querySelectorAll("*").forEach((u) => {
        u instanceof HTMLElement && (u.style.userSelect = "none", u.style.touchAction = "none");
      }));
    }
    function Y() {
      m.value && (D(), m.value.querySelectorAll("*").forEach((u) => {
        u instanceof HTMLElement && (u.style.userSelect = "auto", u.style.touchAction = "auto");
      }));
    }
    function X(u) {
      return !(i.value && u.pointerType !== "touch");
    }
    function ae() {
      Q({
        transition: o.isReducedMotion.value ? "none" : `${an}ms cubic-bezier(0.76, 0, 0.24, 1)`,
        transform: "translate3d(0px, 0px, 0px)",
        opacity: "1"
      });
    }
    function re(u) {
      if (!s.root.value || !m.value)
        return !1;
      const { clientWidth: a, offsetLeft: y } = m.value, j = y + s.root.value.offsetLeft, O = j + a;
      return u.clientX > j && u.clientX < O;
    }
    function ue(u) {
      return G(u) ? Oe.Mouse : Oe.Touch;
    }
    function ee() {
      t.clearDebounceTimeout(), t.pause();
    }
    function te(u) {
      t.clearDebounceTimeout(), t.resumeWithDebounce(u);
    }
    function K(u) {
      X(u) || Y();
    }
    function Ae(u) {
      if (X(u) && (u.stopPropagation(), !!m.value && u.button === 0 && !(E.isPressed || E.isClearing))) {
        if (d.value && Array.from(m.value.querySelectorAll(d.value)).includes(u.target)) {
          G(u) || (ee(), te(Oe.TouchExternal));
          return;
        }
        G(u) || ee(), N({
          startX: u.clientX,
          isPressed: !0
        });
      }
    }
    function ye(u) {
      if (!X(u) || (u.stopPropagation(), !E.isPressed || E.isClearing))
        return;
      const { clientWidth: a } = m.value;
      Q({
        transition: "none",
        transform: `translate3d(${E.currentX}px, 0px, 0px)`,
        opacity: `${1 - Math.abs(E.currentX) / a * (1 / h.value)}`
      }), N({
        currentX: u.clientX - E.startX
      }), Math.abs(E.currentX) > a * h.value && (E.isClearing = !0, Re(u));
    }
    function Re(u) {
      if (r.item.destroy(), G(u) && re(u)) {
        const a = s.getSortedItems();
        a[a.length - 1].contains(m.value) || ee();
      } else
        te(ue(u));
      N({
        isClearing: !1
      });
    }
    function de(u) {
      X(u) && (u.stopPropagation(), !(!E.isPressed || E.isClearing) && (G(u) && re(u) ? ee() : te(ue(u)), ae(), N({
        startX: 0,
        currentX: 0,
        isPressed: !1
      })));
    }
    function ne(u) {
      X(u) && (u.stopPropagation(), !(!E.isPressed || E.isClearing) && (ae(), N({
        startX: 0,
        currentX: 0,
        isPressed: !1
      }), te(ue(u))));
    }
    const _e = [
      ["pointerenter", K],
      ["pointerdown", Ae],
      ["pointermove", ye],
      ["pointerup", de],
      ["pointerleave", ne]
    ];
    function Fe() {
      m.value && _e.forEach(([u, a]) => {
        m.value.addEventListener(u, a);
      });
    }
    function Ee() {
      m.value && _e.forEach(([u, a]) => {
        m.value.removeEventListener(u, a);
      });
    }
    return M(
      _,
      (u, a, y) => {
        ve(() => {
          u && (ge(), ve(Fe));
        }), y(() => {
          Ee(), Y();
        });
      },
      { immediate: !0, flush: "post" }
    ), U(Ee), (u, a) => g.value ? J(u.$slots, "default", { key: 1 }) : (p(), b("div", {
      key: 0,
      ref_key: "itemRef",
      ref: m,
      style: Te(B.value)
    }, [
      J(u.$slots, "default")
    ], 4));
  }
});
let Ge = 0;
function le(n) {
  Ge++;
  let e = {};
  const t = `notivue:id:${Ge}`;
  window.addEventListener(t, s, {
    once: !0
  });
  function s(o) {
    e = o.detail;
  }
  return window.dispatchEvent(
    new CustomEvent("notivue:push", {
      detail: v(l({}, n), {
        type: n.type,
        resultEventName: t
      })
    })
  ), e;
}
const es = {
  success: (n) => le(v(l({}, n), { type: "success" })),
  info: (n) => le(v(l({}, n), { type: "info" })),
  error: (n) => le(v(l({}, n), { type: "error" })),
  warning: (n) => le(v(l({}, n), { type: "warning" })),
  promise: (n) => le(v(l({}, n), { type: "promise" })),
  load: (n) => le(v(l({}, n), { type: "promise" })),
  clearAll() {
    window.dispatchEvent(new CustomEvent("notivue:clear-all"));
  },
  destroyAll() {
    window.dispatchEvent(new CustomEvent("notivue:destroy-all"));
  }
}, rt = Symbol(""), rn = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]', ut = {
  comboKey: "n",
  handleClicks: !0,
  leaveMessage: "You're leaving the notifications stream. Press Control + N to navigate it again.",
  emptyMessage: "No notifications to navigate",
  renderAnnouncement: !0,
  maxAnnouncements: 2
};
function un() {
  const n = F(!1), e = () => n.value = !0, t = () => n.value = !1, s = [
    ["keydown", e],
    ["mousedown", t],
    ["touchstart", t]
  ];
  return z(() => {
    s.forEach(([o, r]) => document.addEventListener(o, r));
  }), U(() => {
    s.forEach(([o, r]) => document.removeEventListener(o, r));
  }), { isKeyboardFocus: n };
}
function ln() {
  const { root: n } = x().elements, e = F(null);
  function t(o) {
    var i;
    const r = o.target instanceof HTMLElement;
    r && ((i = n.value) != null && i.contains(o.target)) || r && (e.value = o.target);
  }
  function s() {
    e.value ? e.value.focus() : (document.activeElement instanceof HTMLElement && document.activeElement.blur(), document.body.focus());
  }
  return z(() => {
    document.addEventListener("focus", t, !0);
  }), U(() => {
    document.removeEventListener("focus", t, !0);
  }), { focusLastElement: s };
}
const cn = /* @__PURE__ */ C({
  __name: "NotivueKeyboardImpl",
  props: /* @__PURE__ */ ie({
    comboKey: {},
    handleClicks: { type: Boolean },
    leaveMessage: {},
    emptyMessage: {},
    renderAnnouncement: { type: Boolean },
    maxAnnouncements: {}
  }, ut),
  setup(n) {
    const e = n, { comboKey: t, handleClicks: s, leaveMessage: o, emptyMessage: r, renderAnnouncement: i, maxAnnouncements: d } = xe(e), g = {
      ariaRole: "alert",
      ariaLive: "assertive",
      skipQueue: !0,
      ariaLiveOnly: !i.value,
      props: {
        isNotivueKeyboard: !0
      }
    }, h = T(() => l({
      message: o.value
    }, g)), S = T(() => l({
      message: r.value
    }, g)), { elements: _, timeouts: m, queue: k } = x(), E = Ue(), { focusLastElement: B } = ln(), { isKeyboardFocus: N } = un(), Q = F({ qualified: [], unqualified: [] }), D = F([]), ge = F([]), Y = F(-1);
    function X(a) {
      Y.value = a;
    }
    let ae = 0, re = !0, ue = [];
    const ee = T(() => {
      const a = {};
      return Q.value.qualified.forEach((y) => a[y] = Y.value), Q.value.unqualified.forEach((y) => a[y] = -1), a;
    });
    function te() {
      D.value.length !== 0 && (X(0), m.setStreamFocus(), m.pause(), ve(() => {
        D.value[0].focus();
      }));
    }
    function K({ announce: a = !0 } = {}) {
      B(), X(-1), m.setStreamFocus(!1), m.resume(), a && ae < d.value && (ae++, se.info(h.value));
    }
    bt(rt, {
      containersTabIndex: ee,
      elementsTabIndex: De(Y)
    }), M(_.containers, Ae, { deep: !0 });
    function Ae(a) {
      const y = { qualified: [], unqualified: [] };
      let j = [], O = [], P = [];
      a.map((Z) => ({ id: Z.dataset.notivueContainer, container: Z })).sort((Z, q) => +q.id - +Z.id).forEach(({ id: Z, container: q }) => {
        const be = Array.from(q.querySelectorAll(rn)).filter(
          (Ie) => Ie instanceof HTMLElement
        );
        P.push(...be), be.length > 1 ? (y.qualified.push(Z), j.push(q)) : (y.unqualified.push(Z), O.push(q));
      }), Q.value = y, D.value = j, ge.value = O, ue = P;
    }
    M(
      D,
      (a, y, j) => {
        if (a.length === 0)
          return;
        const O = a.length > 0, P = a.some((be) => !y.some((Ie) => Ie === be)), Z = P && m.isStreamFocused.value, q = P && !m.isStreamFocused.value || O && re;
        Z ? a[0].focus() : q && Re(), j(() => {
          q && de();
        });
      },
      { flush: "post" }
    );
    function ye(a) {
      !a.shiftKey && a.key === "Tab" && D.value.length > 0 && (a.preventDefault(), re && (re = !1), te(), ve(de));
    }
    function Re() {
      de(), document.addEventListener("keydown", ye);
    }
    function de() {
      document.removeEventListener("keydown", ye);
    }
    M(
      ge,
      (a) => {
        !E.enqueue.value || !m.isStreamFocused.value || a.length > 0 && (D.value.length > 0 ? D.value[0].focus() : K({ announce: !1 }));
      },
      { flush: "post" }
    );
    let ne = !1;
    M(
      _.root,
      (a, y, j) => {
        function O(P) {
          if (P.preventDefault(), P.stopPropagation(), !!m.isStreamFocused.value && N.value) {
            if (ne)
              return ne = !1;
            a != null && a.contains(P.relatedTarget) || K();
          }
        }
        a && a.addEventListener("focusout", O), j(() => {
          a && a.removeEventListener("focusout", O);
        });
      },
      { immediate: !0, flush: "post" }
    );
    function _e(a) {
      let y = 0;
      if (D.value.some((O, P) => {
        if (O.contains(a.target) || O === a.target)
          return y = P, !0;
      })) {
        if (a.key === "Escape")
          return a.preventDefault(), ne = !0, K();
        if (!s.value)
          return;
        if ((a.target instanceof HTMLButtonElement || a.target instanceof HTMLAnchorElement) && (a.key === " " || a.key === " " || a.key === "Enter")) {
          if (a.preventDefault(), ne = !0, a.target.click(), k.length > 0)
            return;
          const P = D.value[y + 1];
          P ? P.focus() : K();
        }
      }
    }
    function Fe(a) {
      if (a.ctrlKey && (a.key === t.value.toLowerCase() || a.key === t.value.toUpperCase())) {
        if (a.preventDefault(), m.isStreamFocused.value)
          return ne = !0, K();
        D.value.length > 0 ? te() : se.info(S.value);
      }
    }
    function Ee(a) {
      var y;
      m.isStreamFocused.value && !N.value && ((y = _.root.value) != null && y.contains(a.target) || K(), ue.includes(a.target) && K());
    }
    const u = [
      ["click", Ee],
      ["keydown", _e],
      ["keydown", Fe]
    ];
    return z(() => {
      u.forEach(([a, y]) => document.addEventListener(a, y));
    }), U(() => {
      u.forEach(([a, y]) => {
        document.removeEventListener(a, y);
      });
    }), (a, y) => J(a.$slots, "default", I(w({ containersTabIndex: ee.value, elementsTabIndex: Y.value })));
  }
}), ts = /* @__PURE__ */ C({
  __name: "NotivueKeyboard",
  props: /* @__PURE__ */ ie({
    comboKey: {},
    handleClicks: { type: Boolean },
    leaveMessage: {},
    emptyMessage: {},
    renderAnnouncement: { type: Boolean },
    maxAnnouncements: {}
  }, ut),
  setup(n) {
    const e = n;
    return (t, s) => (p(), V(c(Ke), null, {
      default: oe(() => [
        $e(cn, I(w(e)), {
          default: oe(({ containersTabIndex: o, elementsTabIndex: r }) => [
            J(t.$slots, "default", I(w({ containersTabIndex: o, elementsTabIndex: r })))
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }));
  }
});
function ns() {
  return ke ? {
    elementsTabIndex: F(-1),
    containersTabIndex: T(() => ({}))
  } : et(rt);
}
const dn = /* @__PURE__ */ A("path", { d: "M6,-0c-3.308,-0 -6,2.692 -6,6c-0,3.308 2.692,6 6,6c3.308,-0 6,-2.692 6,-6c-0,-3.308 -2.692,-6 -6,-6Zm3.123,3.989l-3.877,4.616c-0.086,0.102 -0.213,0.162 -0.346,0.164l-0.008,0c-0.131,0 -0.256,-0.055 -0.343,-0.153l-1.662,-1.846c-0.081,-0.085 -0.126,-0.199 -0.126,-0.316c0,-0.254 0.209,-0.462 0.462,-0.462c0.135,0 0.263,0.059 0.35,0.161l1.307,1.451l3.536,-4.209c0.087,-0.101 0.215,-0.159 0.349,-0.159c0.253,-0 0.461,0.208 0.461,0.461c0,0.107 -0.036,0.21 -0.103,0.292Z" }, null, -1), fn = [
  dn
], Ve = /* @__PURE__ */ C({
  __name: "SuccessIcon",
  setup(n) {
    return (e, t) => (p(), b("svg", I(w(c(ce))), fn, 16));
  }
}), vn = /* @__PURE__ */ A("path", { d: "M6,-0c-3.308,-0 -6,2.692 -6,6c-0,3.308 2.692,6 6,6c3.308,-0 6,-2.692 6,-6c-0,-3.308 -2.692,-6 -6,-6Zm-0,9.228c-0.316,0 -0.577,-0.26 -0.577,-0.577c0,-0.316 0.261,-0.577 0.577,-0.577c0.316,0 0.577,0.261 0.577,0.577c-0,0.317 -0.261,0.577 -0.577,0.577Zm0.627,-5.802l-0.166,3.519c-0,0.253 -0.208,0.462 -0.462,0.462c-0.253,-0 -0.461,-0.209 -0.461,-0.462l-0.166,-3.518l0,-0.001c-0,-0.009 -0,-0.018 -0,-0.027c-0,-0.344 0.283,-0.627 0.627,-0.627c0.344,0 0.627,0.283 0.627,0.627c-0,0.009 -0,0.018 -0.001,0.027l0.002,-0Z" }, null, -1), mn = [
  vn
], Le = /* @__PURE__ */ C({
  __name: "ErrorIcon",
  setup(n) {
    return (e, t) => (p(), b("svg", I(w(c(ce))), mn, 16));
  }
}), pn = /* @__PURE__ */ A("path", { d: "M6,0c-3.308,0 -6,2.692 -6,6c0,3.308 2.692,6 6,6c3.308,0 6,-2.692 6,-6c0,-3.308 -2.692,-6 -6,-6Zm0,2.46c0.428,0 0.78,0.352 0.78,0.78c-0,0.428 -0.352,0.78 -0.78,0.78c-0.428,0 -0.78,-0.352 -0.78,-0.78c0,-0.428 0.352,-0.78 0.78,-0.78Zm1.44,6.78l-2.64,0c-0.263,0 -0.48,-0.217 -0.48,-0.48c0,-0.263 0.217,-0.48 0.48,-0.48l0.84,0l0,-2.64l-0.48,0c-0.263,0 -0.48,-0.217 -0.48,-0.48c0,-0.263 0.217,-0.48 0.48,-0.48l0.96,0c0.263,0 0.48,0.217 0.48,0.48l0,3.12l0.84,0c0.263,0 0.48,0.217 0.48,0.48c0,0.263 -0.217,0.48 -0.48,0.48Z" }, null, -1), hn = [
  pn
], gn = /* @__PURE__ */ C({
  __name: "InfoIcon",
  setup(n) {
    return (e, t) => (p(), b("svg", I(w(c(ce))), hn, 16));
  }
}), yn = /* @__PURE__ */ A("path", { d: "M11.963,6.037c-0,3.292 -2.671,5.963 -5.963,5.963c-3.292,0 -5.963,-2.671 -5.963,-5.963c0,-3.292 2.671,-5.962 5.963,-5.962c3.292,-0 5.963,2.67 5.963,5.962Zm-0.918,0c0,-2.785 -2.26,-5.045 -5.045,-5.045c-2.785,0 -5.045,2.26 -5.045,5.045c-0,2.786 2.26,5.046 5.045,5.046c2.785,-0 5.045,-2.26 5.045,-5.046Z" }, null, -1), _n = /* @__PURE__ */ A("path", { d: "M8.401,3.449c0.163,-0.194 0.452,-0.219 0.646,-0.056c0.194,0.163 0.219,0.452 0.056,0.646l-3.853,4.587c-0.085,0.101 -0.21,0.161 -0.343,0.163c-0.133,0.003 -0.26,-0.053 -0.349,-0.151l-1.651,-1.835c-0.169,-0.188 -0.154,-0.479 0.034,-0.648c0.188,-0.169 0.479,-0.154 0.648,0.034l1.298,1.443l3.514,-4.183Z" }, null, -1), En = [
  yn,
  _n
], Je = /* @__PURE__ */ C({
  __name: "SuccessOutlineIcon",
  setup(n) {
    return (e, t) => (p(), b("svg", I(w(c(ce))), En, 16));
  }
}), bn = /* @__PURE__ */ A("path", { d: "M12, 6c0, 3.313 -2.687, 6 -6, 6c-3.313,-0 -6,-2.688 -6,-6c0,-3.313 2.688,-6 6,-6c3.313,-0 6,2.687 6,6Zm-0.923,-0c-0,-2.803 -2.274,-5.077 -5.077,-5.077c-2.803,0 -5.077,2.274 -5.077,5.077c0,2.803 2.274,5.077 5.077,5.077c2.803,-0 5.077,-2.274 5.077,-5.077Z" }, null, -1), Sn = /* @__PURE__ */ A("path", { d: "M5.373,3.426c-0,-0.009 -0,-0.019 -0,-0.028c-0,-0.342 0.279,-0.624 0.621,-0.627c0.002,-0 0.004,-0 0.006,-0c0.344,-0 0.627,0.283 0.627,0.627c-0,0.009 -0,0.019 -0.001,0.028l0,0.001l-0.165,3.518c-0.012,0.246 -0.215,0.44 -0.461,0.44c-0.246,-0 -0.449,-0.194 -0.461,-0.44l-0.166,-3.518l0,-0.001Z" }, null, -1), Cn = /* @__PURE__ */ A("path", { d: "M6,9.228c-0.316,0 -0.577,-0.26 -0.577,-0.577c0,-0.316 0.261,-0.577 0.577,-0.577c0.316,0 0.577,0.261 0.577,0.577c-0,0.317 -0.261,0.577 -0.577,0.577Z" }, null, -1), Tn = [
  bn,
  Sn,
  Cn
], Ne = /* @__PURE__ */ C({
  __name: "ErrorOutlineIcon",
  setup(n) {
    return (e, t) => (p(), b("svg", I(w(c(ce))), Tn, 16));
  }
}), An = /* @__PURE__ */ A("path", { d: "M6, 0c3.313, 0 6, 2.687 6, 6c-0, 3.313 -2.687, 6 -6, 6c-3.313,-0 -6,-2.687 -6,-6c0,-3.313 2.687,-6 6,-6Zm0, 0.96c-2.783, 0 -5.04, 2.257 -5.04, 5.04c0, 2.783 2.257, 5.04 5.04, 5.04c2.783, 0 5.04,-2.257 5.04,-5.04c-0,-2.783 -2.257,-5.04 -5.04,-5.04Z" }, null, -1), Rn = /* @__PURE__ */ A("path", { d: "M6.6, 8.28l0.84, 0c0.265, 0 0.48, 0.215 0.48, 0.48c-0, 0.265 -0.215, 0.48 -0.48, 0.48l-2.64,-0c-0.265, 0 -0.48,-0.215 -0.48,-0.48c-0,-0.265 0.215,-0.48 0.48,-0.48l0.84, 0l-0,-2.64l-0.48, 0c-0.265, 0 -0.48,-0.215 -0.48,-0.48c-0,-0.265 0.215,-0.48 0.48,-0.48l0.96, 0c0.265, 0 0.48, 0.215 0.48, 0.48l-0, 3.12Z" }, null, -1), Fn = /* @__PURE__ */ A("path", { d: "M6, 2.46c-0.428, 0 -0.78, 0.352 -0.78, 0.78c-0, 0.428 0.352, 0.78 0.78, 0.78c0.428, 0 0.78,-0.352 0.78,-0.78c-0,-0.428 -0.352,-0.78 -0.78,-0.78Z" }, null, -1), In = [
  An,
  Rn,
  Fn
], wn = /* @__PURE__ */ C({
  __name: "InfoOutlineIcon",
  setup(n) {
    return (e, t) => (p(), b("svg", I(w(c(ce))), In, 16));
  }
}), Pn = /* @__PURE__ */ A("path", {
  d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",
  opacity: ".25"
}, null, -1), On = /* @__PURE__ */ A("path", {
  d: "M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z",
  class: "Notivue__spinner"
}, null, -1), Ln = [
  Pn,
  On
], lt = /* @__PURE__ */ C({
  __name: "PromiseIcon",
  setup(n) {
    return (e, t) => (p(), b("svg", I(w(v(l({}, c(Ze)), { width: 28, height: 28, fill: "currentColor" }))), Ln, 16));
  }
}), Nn = /* @__PURE__ */ A("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}, null, -1), Dn = /* @__PURE__ */ A("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
}, null, -1), Mn = [
  Nn,
  Dn
], ct = /* @__PURE__ */ C({
  __name: "CloseIcon",
  setup(n) {
    return (e, t) => (p(), b("svg", I(w(c(xn))), Mn, 16));
  }
}), Ze = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, ce = v(l({}, Ze), {
  fill: "currentColor",
  viewBox: "0 0 12 12"
}), xn = v(l({}, Ze), {
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}), $n = {
  [f.SUCCESS]: R(Ve),
  [f.ERROR]: R(Le),
  [f.INFO]: R(gn),
  [f.WARNING]: R(Le),
  [f.PROMISE]: R(lt),
  [f.PROMISE_RESOLVE]: R(Ve),
  [f.PROMISE_REJECT]: R(Le),
  close: R(ct)
}, ss = {
  [f.SUCCESS]: R(Je),
  [f.ERROR]: R(Ne),
  [f.INFO]: R(wn),
  [f.WARNING]: R(Ne),
  [f.PROMISE]: R(lt),
  [f.PROMISE_RESOLVE]: R(Je),
  [f.PROMISE_REJECT]: R(Ne),
  close: R(ct)
}, he = {
  "--nv-width": "350px",
  "--nv-spacing": "0.625rem",
  "--nv-radius": "0.625rem",
  "--nv-icon-size": "1.25rem",
  "--nv-title-size": "0.925rem",
  "--nv-message-size": "0.925rem",
  "--nv-y-align": "center"
}, We = {
  "--nv-shadow": "rgba(0, 0, 0, 0.06) 0px 4px 6px -1px, rgba(0, 0, 0, 0.03) 0px 2px 4px -1px"
}, kn = v(l(l({}, he), We), {
  "--nv-global-bg": "#FFF",
  "--nv-global-fg": "#171717",
  "--nv-success-accent": "#28B780",
  "--nv-error-accent": "#E74C3C",
  "--nv-warning-accent": "#F59E0B",
  "--nv-info-accent": "#3E8EFF",
  "--nv-promise-accent": "#171717"
}), os = v(l(l({}, he), We), {
  "--nv-success-bg": "#E9FAEF",
  "--nv-success-accent": "#059669",
  "--nv-success-fg": "#057452",
  "--nv-error-bg": "#FEEFEF",
  "--nv-error-accent": "#E6523C",
  "--nv-error-fg": "#C5412C",
  "--nv-warning-bg": "#FFF0D8",
  "--nv-warning-accent": "#F48533",
  "--nv-warning-fg": "#81471D",
  "--nv-info-bg": "#DEF0FA",
  "--nv-info-accent": "#1F70AC",
  "--nv-info-fg": "#1F70AC",
  "--nv-promise-bg": "#FFF",
  "--nv-promise-accent": "#334155",
  "--nv-promise-fg": "#334155"
}), is = v(l(l({}, he), We), {
  "--nv-global-accent": "#FFF",
  "--nv-global-fg": "#FFF",
  "--nv-success-bg": "#178570",
  "--nv-error-bg": "#C94430",
  "--nv-info-bg": "#117AAE",
  "--nv-warning-bg": "#FFE556",
  "--nv-warning-fg": "#4F5358",
  "--nv-warning-accent": "#4F5358",
  "--nv-promise-bg": "#FFF",
  "--nv-promise-fg": "#334155",
  "--nv-promise-accent": "#64748B"
}), as = v(l({}, he), {
  "--nv-border-width": "1px",
  "--nv-global-bg": "#1F1F1F",
  "--nv-global-border": "#414141",
  "--nv-global-fg": "#D0D0D0",
  "--nv-success-accent": "#8EF997",
  "--nv-error-accent": "#FF7777",
  "--nv-warning-accent": "#FFE554",
  "--nv-info-accent": "#5FD4FF",
  "--nv-promise-accent": "#D0D0D0"
}), rs = v(l({}, he), {
  "--nv-border-width": "1px",
  "--nv-global-bg": "#20252E",
  "--nv-global-border": "#353b45",
  "--nv-global-fg": "#dfdfdf",
  "--nv-success-accent": "#34D399",
  "--nv-error-accent": "#FF7777",
  "--nv-warning-accent": "#FFE554",
  "--nv-info-accent": "#5FD4FF",
  "--nv-promise-accent": "#D0D0D0"
}), $ = {
  NOTIFICATION: L + "notification",
  ICON: L + "icon",
  CONTENT: L + "content",
  TITLE: L + "content-title",
  MESSAGE: L + "content-message",
  CLOSE: L + "close",
  CLOSE_ICON: L + "close-icon",
  TRANSITION: L + "transition",
  PROGRESS: L + "progress",
  DUPLICATE: L + "duplicate"
}, jn = {
  icons: () => $n,
  theme: () => kn,
  hideClose: !1,
  closeAriaLabel: "Close"
}, Un = ["data-notivue", "data-notivue-has-title"], Bn = ["aria-live", "role"], Kn = ["textContent"], Zn = ["textContent"], Wn = ["aria-label"], zn = ["textContent"], us = /* @__PURE__ */ C({
  __name: "Notification",
  props: /* @__PURE__ */ ie({
    item: {},
    icons: {},
    theme: {},
    closeAriaLabel: {},
    hideClose: { type: Boolean }
  }, jn),
  setup(n) {
    const e = n, t = pe(e.icons[e.item.type]), s = e.icons.close;
    return M(
      () => e.item.type,
      (o) => t.value = e.icons[o],
      { flush: "sync" }
    ), (o, r) => (p(), b("div", {
      class: W([c($).NOTIFICATION, { [c($).DUPLICATE]: o.item.duplicateCount > 0 }]),
      key: o.item.duplicateCount,
      "data-notivue": o.item.type,
      "data-notivue-has-title": !!o.item.title,
      style: Te(o.theme)
    }, [
      t.value ? (p(), b(tt, { key: 0 }, [
        typeof t.value == "object" ? (p(), V(St, {
          key: 0,
          name: c($).TRANSITION,
          mode: "out-in"
        }, {
          default: oe(() => [
            typeof t.value == "object" ? (p(), V(He(t.value), {
              key: o.item.duplicateCount,
              class: W(c($).ICON),
              "aria-hidden": "true"
            }, null, 8, ["class"])) : H("", !0)
          ]),
          _: 1
        }, 8, ["name"])) : typeof t.value == "string" ? (p(), b("div", {
          key: 1,
          class: W(c($).ICON),
          "aria-hidden": "true"
        }, fe(t.value), 3)) : H("", !0)
      ], 64)) : H("", !0),
      A("div", {
        class: W(c($).CONTENT),
        "aria-live": o.item.ariaLive,
        role: o.item.ariaRole,
        "aria-atomic": "true"
      }, [
        o.item.title ? (p(), b("h3", {
          key: 0,
          class: W(c($).TITLE),
          textContent: fe(c(o.item.title))
        }, null, 10, Kn)) : H("", !0),
        A("p", {
          class: W(c($).MESSAGE),
          textContent: fe(c(o.item.message))
        }, null, 10, Zn)
      ], 10, Bn),
      !e.hideClose && c(s) && o.item.type !== "promise" ? (p(), b("button", {
        key: 1,
        class: W(c($).CLOSE),
        "aria-label": o.closeAriaLabel,
        type: "button",
        tabindex: "-1",
        onClick: r[0] || (r[0] = //@ts-ignore
        (...i) => o.item.clear && o.item.clear(...i))
      }, [
        typeof c(s) == "object" ? (p(), V(He(c(s)), {
          key: 0,
          class: W(c($).CLOSE_ICON)
        }, null, 8, ["class"])) : typeof c(s) == "string" ? (p(), b("div", {
          key: 1,
          "aria-hidden": "true",
          textContent: fe(c(s))
        }, null, 8, zn)) : H("", !0)
      ], 10, Wn)) : H("", !0),
      J(o.$slots, "default")
    ], 14, Un));
  }
}), ls = /* @__PURE__ */ C({
  __name: "NotificationProgress",
  props: {
    item: {}
  },
  setup(n) {
    const { isStreamPaused: e } = Ue();
    return (t, s) => Number.isFinite(t.item.duration) ? (p(), b("div", {
      key: t.item.duplicateCount,
      class: W(c($).PROGRESS),
      style: Te({
        animationPlayState: c(e) ? "paused" : "running",
        "--nv-anim-dur": `${t.item.duration}ms`
      })
    }, null, 6)) : H("", !0);
  }
});
export {
  nt as DEFAULT_CONFIG,
  us as Notification,
  ls as NotificationProgress,
  us as Notifications,
  Jn as Notivue,
  Qn as NotivueAstro,
  ts as NotivueKeyboard,
  Yn as NotivueSwipe,
  Hn as createNotivue,
  as as darkTheme,
  $n as filledIcons,
  kn as lightTheme,
  is as materialTheme,
  ss as outlinedIcons,
  os as pastelTheme,
  se as push,
  es as pushAstro,
  rs as slateTheme,
  $t as updateConfig,
  Vn as useNotifications,
  Ue as useNotivue,
  ns as useNotivueKeyboard,
  Gn as usePush
};
